import { FvIconRadio } from '../../../../../ui/icon/FvIcons.tsx';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema.ts';
import { OptionsTranslationSchema } from '../../translations/OptionsTranslationSchema.ts';
import { createCommonFormSchema } from '../common/createCommonFormSchema.ts';
import { SingleSelectOption } from './component/SingleSelectOption.tsx';
import { getSingleSelectWidgetReference } from './getSingleSelectWidgetReference.ts';
import { type ISingleSelectWidget } from './ISingleSelectWidget.ts';
import {
  SingleSelectConfigComponent,
  singleSelectInputConfigValidator,
} from './SingleSelectConfigComponent.tsx';
import { SingleSelectWidgetComponent } from './SingleSelectWidgetComponent.tsx';
import { getSingleSelectWidgetSchema } from './SingleSelectWidgetSchema.ts';

export const SingleSelectWidgetType: IWidgetType<ISingleSelectWidget> = {
  type: WidgetType.Select,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo scelta singola',
  icon: <FvIconRadio />,
  hasValue: true,
  getReference: getSingleSelectWidgetReference,
  formComponent: SingleSelectWidgetComponent,
  createFormSchema: ({ widget }) => {
    return createCommonFormSchema(getSingleSelectWidgetSchema(widget), widget);
  },
  previewComponent: SingleSelectWidgetComponent,
  optionComponent: SingleSelectOption,
  configValidator: singleSelectInputConfigValidator,
  configComponent: SingleSelectConfigComponent,
  translationSchema: tran.widget({
    ...InputCommonTranslationSchema.objectShape,
    options: OptionsTranslationSchema,
  }),
  rules: [RequiredRule, CustomWarningsRule],
};
